import { useContext, useEffect, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import { logoutRedirect } from "src/async/fetch";
import { AuthContext } from "src/context/auth";
import { useWorkspaceSwitching } from "src/context/WorkspaceSwitchingContext";
import useUrlQueryParams from "src/hooks/useUrlQueryParams";
import Dashboardlayout from "src/layouts/DashboardLayout";

const ProtectedRouteInner = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { user, setUser } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { workspace_id } = useParams();
  const { page, form, document } = useUrlQueryParams();
  const { startSwitching } = useWorkspaceSwitching();

  useEffect(() => {
    if (!isLoaded) {
      startSwitching();
    }
  }, [isLoaded, startSwitching]);

  const loadUser = async () => {
    if (user?._id) {
      setIsLoaded(true);
      return;
    }

    try {
      const { data: resData } = await apiRequest("post", "/portal/users/self/details", {
        body: { token: localStorage.getItem("accessToken"), access_token: localStorage.getItem("accessToken") },
      });

      if (resData.status !== 200) logoutRedirect();
      setUser(resData.data);
    } catch (error) {
      if (error.message !== "Failed to fetch" && error.message !== "The user aborted a request.") logoutRedirect();
    } finally {
      setIsLoaded(true);
    }
  };

  const getPublicGroupDetails = async () => {
    try {
      const { data: resData } = await apiRequest(
        "get",
        "/portal/workspaces/:workspace_id/groups/:group_id/public",
        {
          params: { workspace_id, group_id: searchParams.get("group") },
          queries: { page, form, document },
        },
        { returnErrorWithstatus: true },
      );

      if (resData?.status !== 200) {
        loadUser();
      }
    } catch (error) {
      if (error.message !== "canceled") {
        if (error.message !== "Failed to fetch" && error.message !== "The user aborted a request.") loadUser();
      }
    } finally {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken")) loadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      if (location?.pathname?.includes("/embed") && workspace_id && searchParams.get("group")) {
        getPublicGroupDetails();
      } else {
        logoutRedirect();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?._id, location?.pathname, workspace_id, searchParams]);

  if (window.location.pathname.includes("/embeded/") || window.location.pathname.includes("/embed/items/")) {
    return <Dashboardlayout nested />;
  }

  return <Dashboardlayout />;
};

const ProtectedRoute = () => {
  return <ProtectedRouteInner />;
};

export default ProtectedRoute;
